import { c as _c } from "react/compiler-runtime";
import { IcoShield40 } from '@onefootprint/icons';
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { WithEntityProps } from '@/entities/components/details/components/with-entity';
import hasDataIdentifier from '@/utils/has-data-identifier';
import isDiDecryptable from '@/utils/is-di-decryptable';
type ProtectedDetailsProps = WithEntityProps & {
  onClick: () => void;
  isPending: boolean;
};
const REQUIRED_DECRYPTABLE_ATTRS: DataIdentifier[] = ['id.first_name', 'id.last_name', 'id.dob'];
const ProtectedDetails = t0 => {
  const $ = _c(23);
  const {
    entity,
    onClick,
    isPending
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "classicOnboardings.riskSignals.drawer.protectedDetails"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== entity) {
    t2 = REQUIRED_DECRYPTABLE_ATTRS.every(di => !hasDataIdentifier(entity, di) || isDiDecryptable(entity, di));
    $[1] = entity;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const canDecrypt = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoShield40 />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <h1 className="text-label-1">{t4}</h1>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp2);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <p className="text-body-2 text-secondary text-center">{t6}</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="flex flex-col items-center justify-center gap-4">{t3}<div className="flex flex-col items-center justify-center gap-2">{t5}{t7}</div></div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== canDecrypt || $[16] !== isPending || $[17] !== onClick || $[18] !== t) {
    t9 = canDecrypt ? <div className="mt-3"><Button loading={isPending} onClick={onClick}>{t(_temp3)}</Button></div> : <div className="p-4 border border-solid rounded border-tertiary"><p className="text-body-2 text-tertiary text-center">{t(_temp4)}</p></div>;
    $[15] = canDecrypt;
    $[16] = isPending;
    $[17] = onClick;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <section className="flex flex-col items-center justify-center w-full h-full gap-5 py-5 z-2" data-is-decrypted={true}>{t8}{t9}</section>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default ProtectedDetails;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3($_1) {
  return $_1.button;
}
function _temp4($_2) {
  return $_2.noPermission;
}